import React, {useContext, useEffect, useState} from 'react';
import Modal from 'styled-react-modal'
import styled from "styled-components";
import Colors from '../../../helpers/Colors';
import Text from '../Text';
import { Box, makeStyles } from "@material-ui/core";
import Assets from "../../../helpers/assets";
import {AppContext} from "../../../contexts/AppContext";
import {
    getSelectedDeliveryPartnerId,
    isOnGoingTransitionPeriodOrder
} from "../../../helpers/DeliveryPartnerHelper";

const StyledModal = Modal.styled`
width: 42rem;
max-height: 37rem;
display: flex;
align-items: center;
justify-content: center;
background-color: ${Colors.white};
position: absolute;
border-radius: 4.4px;
padding: 66px;
`;

const Container = styled.div`
display: flex;
flex-direction: column;
width: 100%;
align-items: center;
`;


export function DeliveryPartnerCancelHistoryModal({isOpen, onClose, order}) {
    const classes = useStyles();

    const { available3plPartners } = useContext(AppContext)
    const [warningList, setWarningList] = useState([])

    useEffect(() => {
        if (order && order.deliveryDetails.deliveryHistory) {
            const warnings = []

            order.deliveryDetails.deliveryHistory.forEach((history, i) => {
                if (i === order.deliveryDetails.deliveryHistory.length - 1) {
                    const changeCnt = history.deliveryHistoryInfoList.filter(info => info.deliveryEventType === 'DELIVERY_PARTNER_ASSIGNED').length
                    const temp3plId =  order.tempSelected3pl? order.tempSelected3pl.id  : ''
                    const currentPartner = getSelectedDeliveryPartnerId(order, available3plPartners);
                    if ((currentPartner === history.deliveryPartnerId || temp3plId === history.deliveryPartnerId) && changeCnt === 1) {
                        return
                    }
                }
                const warning = {}
                warning.text = `Request for ${available3plPartners.get(history.deliveryPartnerId)} needs to be canceled.`
                warnings.push(warning)
            })
            setWarningList(warnings)
        }
    }, [isOpen])

    return (
        <StyledModal isOpen={isOpen} onBackgroundClick={onClose} onEscapeKeydown={onClose}>
            <Container>
                <Box>
                    <Text className={classes.titleText}>Cancel the requests manually</Text>
                </Box>
                <Box className={classes.descriptionContainer}>
                    <img src={Assets.warningYellow.default} width={20} height={20} alt='' />
                    <Text className={classes.descriptionText}>
                        While trying to find a driver for your order.
                        Multiple requests have been made to below partners.
                        Please cancel the requests on partner dashboards manually.
                    </Text>
                </Box>
                <Box className={classes.msgContainer}>
                {
                    warningList.map((warning,i) => (
                        <Box key={i} className={`${classes.row} ${classes.separator}`}>
                            <Text style={{fontSize: 18}}>{warning.text}</Text>
                        </Box>
                    ))
                }
                </Box>
                <Box className={classes.button} onClick={onClose}>
                    <Text>GOT IT</Text>
                </Box>
            </Container>
        </StyledModal>
    );
}

const useStyles = makeStyles(() => ({
    titleText: {
        marginLeft: 0,
        color: Colors.black,
        fontSize: 24,
        fontFamily: 'SFProDisplay-Regular',
        fontWeight: '700',
    },
    descriptionText: {
        color: '#4F4F4F',
        fontSize: 18,
        fontFamily: 'SFProDisplay-Regular',
        fontWeight: 400,
        justifyContent: 'center',
        textAlign: 'start',
        marginLeft: 10,
    },
    button: {
        cursor: 'pointer',
        height: 50,
        width: 224,
        backgroundColor: Colors.white,
        color: Colors.boldBlue,
        border: `1px solid ${Colors.boldBlue}`,
        borderRadius: 5,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 20
    },
    descriptionContainer: {
        display: "flex",
        alignSelf: "start",
        margin: '8px 0'
    },
    msgContainer: {
        width: "100%",
        maxHeight: '288px',
        overflowY: 'auto',
    },
    row: {
        minHeight: "72px",
        marginRight: 0,
        color: Colors.black,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        fontFamily: 'SFProDisplay-Regular',
        fontWeight: 500
    },
    separator: {
        borderBottom: "1px solid #F2F2F2"
    }
}));
